import { Button, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { MobileTitle } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import {
  OUTDOOR_GYM_EQUIPMENT_ID,
  responsiveMargin,
} from '../../../../utils/enum';
import {
  sportingDefaultValue,
  sportingSchema,
} from '../Common/DefaultValuesAndSchema';
import { EditSportingForm } from '../Common/EditCategoryForm';
import { GoBackIconButton } from './GoBackIconButton';

export default function EditSportingCategoryMobile() {
  const navigate = useNavigate();
  const { subCategoryId } = useParams();
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...sportingSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...sportingDefaultValue,
    },
    shouldUnregister: false,
  });

  const [putCategoryResult, putCategory] = useAuthAxios({
    method: 'PUT',
    url: `/api/v1/subcategory/${subCategoryId}`,
  });
  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      subCategoryType: values.subCategoryType,
      notes: values.notes,
      categoryId: OUTDOOR_GYM_EQUIPMENT_ID,
    };
    putCategory({ data: payload });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GoBackIconButton form={form} />
        <MobileTitle>운동기구 수정</MobileTitle>
        <Button variant="text" onClick={onSubmit}>
          수정
        </Button>
        <ApiResultModal
          apiResult={putCategoryResult}
          successTitle="수정됐습니다."
          successCode={200}
          onSuccessClose={() => {
            navigate(`/category`);
          }}
          failTitle="관리자에게 문의해주세요."
          ErrorCodeTable={{
            PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          }}
        />
      </Stack>
      <EditSportingForm form={form} subcategoryId={subCategoryId} />
    </Stack>
  );
}
